import React, { Suspense } from "react";
import ProtectedRoute from "ProtectedRoute";
import FactCheckOutlinedIcon from "@mui/icons-material/FactCheckOutlined";

// audit-api admin viewer. Phase 1 frontend module — backs the dedicated
// audit-api service (port 5060) introduced by the platform decomposition,
// NOT the v1-era flex2-api AuditEvents controller. v2 adds hash-chain
// verification UX.
//
// appMode: flex2 only (platform tooling). Lane: enterprise admin tier —
// the live page does its own super-admin gating via ProtectedRoute.

const AuditApiEventsViewer = React.lazy(() =>
  import("audit/pages/AuditApiEventsViewer")
);

const auditRoutes = [
  {
    type: "collapse",
    name: "Platform Audit",
    key: "audit-api",
    icon: <FactCheckOutlinedIcon />,
    appMode: "flex2",
    laneKey: "lane.platform-admin",
    collapse: [
      {
        name: "audit-api events",
        key: "audit-api-events",
        route: "/platform/audit-api/events",
        appMode: "flex2",
        component: (
          <ProtectedRoute
            component={
              <Suspense fallback={<div>Loading audit viewer…</div>}>
                <AuditApiEventsViewer />
              </Suspense>
            }
          />
        ),
      },
    ],
  },
];

export default auditRoutes;
